import * as React from "react";
import { Building2 } from "lucide-react";
import { UniversalSelector } from "@/components/ui/universal-selector";

interface Supplier {
  id: string;
  name: string;
}

interface SupplierSelectorProps {
  suppliers: Supplier[];
  value: string;
  onValueChange: (value: string) => void;
  placeholder?: string;
  allowFreeText?: boolean;
  freeTextValue?: string;
  onFreeTextChange?: (value: string) => void;
  label?: string;
  error?: string;
  inputRef?: React.RefObject<HTMLInputElement>;
  onEnterPress?: () => void;
  canAddNew?: boolean;
  onAddNew?: (name: string) => Promise<void>;
  required?: boolean;
}

export function SupplierSelector({
  suppliers,
  value,
  onValueChange,
  placeholder = "Selecione um fornecedor",
  allowFreeText = false,
  freeTextValue = "",
  onFreeTextChange,
  label = "Fornecedor",
  error,
  inputRef,
  onEnterPress,
  canAddNew = false,
  onAddNew,
  required = true
}: SupplierSelectorProps) {
  
  return (
    <UniversalSelector
      items={suppliers}
      value={value}
      onValueChange={onValueChange}
      placeholder={placeholder}
      allowFreeText={allowFreeText}
      freeTextValue={freeTextValue}
      onFreeTextChange={onFreeTextChange}
      label={label}
      error={error}
      inputRef={inputRef}
      onEnterPress={onEnterPress}
      icon={Building2}
      required={required}
      canAddNew={canAddNew}
      onAddNew={onAddNew}
      addNewLabel="Adicionar Novo Fornecedor"
    />
  );
}